// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__aIjWu","iconWithCounter":"styles_iconWithCounter__2775R","counterForLabel":"styles_counterForLabel__8KzuA","counterForIcon":"styles_counterForIcon__k6_SJ"};